module.exports = __webpack_public_path__ + "static/media/profile-placeholder.66b68f3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/User/img/profile-placeholder.svg
// module id = 323
// module chunks = 0